import {DigitalPageItem} from '../../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Sample,
  Title: 'Hello!',
  ProductCode: 'car47',
  Description: '<p>Try some of the online revision included with our Chemistry revision books. Get full access to all the features when you <a href="[[external_domain]]/info/new-gcse-aqa-science-books" class="link-button">buy your book</a> and unlock CGP RevisionHub with the unique code printed inside!</p>',
  Credits: 'Contributors: Ben Ffrancon Dowds, Jackie Shaw, Coralie Stewart, Sarah Sweeney\n' +
    '\n' +
    'Proofreaders: Pat Dunn, Natalie Handley, Natalie Pomier, Véronique Robine\n' +
    '\n' +
    'AQA material is reproduced by permission of AQA. The worked solutions to questions and commentaries on questions and possible answers in this product have neither been provided by nor approved by AQA.\n' +
    '\n' +
    'Audio produced by Voice Talent Online.\n' +
    '\n' +
    'Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2024. All rights reserved.',
  FreeSampleContent: '<p>This is a free sample of the CGP RevisionHub for GCSE Chemistry. <a href="[[external_domain]]/info/new-gcse-aqa-science-books" class="link-button" style="color: #FF9335;">Order</a> your book now for full access to online Chemistry revision.</p>',
};
